import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Button from '../../common/Button';
import MultipleSelect from '../../common/MultipleSelect';
import styles from './AssignTo.module.scss';

function AssignTo(props) {
  const { productsCount, canUserDoActions } = props;

  const [selected, setSelected] = useState([]);

  const revoke = () => {
    submit({
      dropship: false,
      replenishment: false,
    });
  };

  const approve = () => {
    submit({
      dropship: true,
      replenishment: true,
    });
  };

  const submit = (value) => {
    props.submit({
      ...value,
      retailers: selected,
    });
  };

  const isDisabled = selected.length === 0 || productsCount === 0;
  const retailersOptions = props.retailers.map((retailer) => {
    return {
      label: retailer.name,
      value: retailer.id,
      disabled: !canUserDoActions && !!retailer.settings?.managed_by_cymbio,
    };
  });

  return (
    <div className="column_filter">
      <div className={styles.assign}>Update Catalogue On Sales Channels</div>

      <MultipleSelect options={retailersOptions} selected={selected} onChange={setSelected} sort />

      <div className={styles.buttons}>
        <Button disabled={isDisabled} color="white" text="Revoke" onClick={revoke} />

        <Button disabled={isDisabled} text="Approve" onClick={approve} />
      </div>
    </div>
  );
}

export default AssignTo;

AssignTo.defaultProps = {
  submit: undefined,
};

AssignTo.propTypes = {
  retailers: PropTypes.array.isRequired,
  submit: PropTypes.func.isRequired,
  productsCount: PropTypes.number.isRequired,
};
